/** Local stand-in for the standalone app's legacy platform client.
 *
 *  Brands come from the cowork API in this build — `/v1/brands` syncs the
 *  team's Beatly brands and is the same source the header badge reads, so
 *  going through it keeps every brand surface on one answer.
 *
 *  This used to return `[]`. That silently disabled the whole brand-selection
 *  path in CoworkPage: `activeBrandId` stayed undefined, so Brand OS and the
 *  Brand Wiki both fell back to the `'default'` brand and showed a different
 *  brand than the badge, and the in-surface brand switcher had nothing to
 *  offer. Returning the real list is what the caller always expected.
 */
import { coworkApi } from '../api/coworkApi';

export interface LegacyTeamBrand {
  brand_id: string;
  name: string;
  logo_url?: string;
}

export async function getTeamBrands(_teamId?: string, _token?: string): Promise<LegacyTeamBrand[]> {
  const { brands } = await coworkApi.brands.list();
  return brands.map((b) => ({
    brand_id: b.brandId,
    name: b.brandName,
    logo_url: b.brandLogoUrl,
  }));
}
